import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { notifications } from '@mantine/notifications'
import type { ProveedorEdicion, ProveedorEntrada } from '@serkat/shared'
import { ErrorApi } from '../../../api/cliente'
import { proveedoresApi, type FiltroProveedores } from '../api'

const CLAVE = 'proveedores'

export function useProveedores(filtro: FiltroProveedores) {
  return useQuery({
    queryKey: [CLAVE, filtro],
    queryFn: () => proveedoresApi.listar(filtro),
    placeholderData: (previo) => previo,
  })
}

function avisarError(e: unknown) {
  notifications.show({
    color: 'red',
    title: 'No se pudo guardar',
    message: e instanceof ErrorApi ? e.message : 'Error inesperado',
  })
}

export function useGuardarProveedor() {
  const qc = useQueryClient()

  const invalidar = () => qc.invalidateQueries({ queryKey: [CLAVE] })

  const crear = useMutation({
    mutationFn: (datos: ProveedorEntrada) => proveedoresApi.crear(datos),
    onSuccess: () => {
      notifications.show({ color: 'teal', message: 'Proveedor registrado' })
      void invalidar()
    },
    onError: avisarError,
  })

  const actualizar = useMutation({
    mutationFn: ({ id, datos }: { id: string; datos: ProveedorEdicion }) =>
      proveedoresApi.actualizar(id, datos),
    onSuccess: () => {
      notifications.show({ color: 'teal', message: 'Proveedor actualizado' })
      void invalidar()
    },
    onError: avisarError,
  })

  return { crear, actualizar }
}
